import { render, staticRenderFns } from "./xeSelfRateToc.vue?vue&type=template&id=54cf8088&scoped=true"
import script from "./xeSelfRateToc.vue?vue&type=script&lang=js"
export * from "./xeSelfRateToc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf8088",
  null
  
)

export default component.exports